import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, CurrencyPipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseAlertComponent } from '@fuse/components/alert';
import { QRCodeModule } from 'angularx-qrcode';
import { ProductCategoryDto, ProductDto, SupplierDto, SwimlaneListDto } from 'app/api/models';
import { SupplierService, ProductService } from 'app/api/services';
import { SharedModule } from 'app/core/shared.module';
import { ColourUtil } from 'app/core/utils/color-util';
import { NgxColorsModule } from 'ngx-colors';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxPrintModule } from 'ngx-print';

@Component({
  selector: 'app-add-edit-asset',
  templateUrl: './add-edit-asset.component.html',
  styleUrls: ['./add-edit-asset.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatMenuModule,
    TitleCasePipe,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    FuseAlertComponent,
    MatRadioModule,
    CurrencyPipe,
    TextFieldModule,
    NgxColorsModule,
    NgxDropzoneModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    QRCodeModule,
    NgxPrintModule,
  ]
})
export class AddEditAssetComponent {
  form: UntypedFormGroup;

  public productId: number;
  public product: ProductDto = {};

  public suppliers: SupplierDto[] = [];
  public categories: ProductCategoryDto[] = [];
  public filteredCategories: ProductCategoryDto[] = [];
  public selectedCategory: ProductCategoryDto;
  public swimlanes: SwimlaneListDto[];

  constructor(
    public dialogRef: MatDialogRef<AddEditAssetComponent>,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    public assetService: ProductService,
    public supplierService: SupplierService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  async ngOnInit()
  {
    this.loadSuppliers();
    this.loadCategories();
    await this.loadSwimlanes();

    if (this.data?.productId) {
      this.productId = this.data?.productId;
      this.loadProduct(this.productId);
    }
    else {
      this.buildForm();
    }
  }

  loadProduct(productId: number) {
    this.assetService.apiProductGetProductGet$Json$Response({ productId: productId }).subscribe((res) => {
      if(!res?.body?.data) return;

      this.product = res.body.data;
      this.buildForm();
    });
  }

  loadSuppliers() {
    this.supplierService.apiSupplierGetAllGet$Json().subscribe(res => {
      if(!res?.data) return;

      this.suppliers = res.data;
    });
  }

  loadCategories() {
      this.assetService.apiProductAllCategoriesGet$Json$Response().subscribe(res => {
          if(!res?.body?.data) return;
          
          this.categories = res.body.data;
          this.filteredCategories = this.categories;
          
          this.selectedCategory = this.categories.find(x => x.productCategoryId == this.product?.categoryId) ?? null;
      })
  }

  async loadSwimlanes() {
      var res = await this.assetService.apiProductAssetBoardGet$Json$Response().toPromise();
      if(!res?.body?.data) return;

      this.swimlanes = res.body.data.swimlanes;

      this.cdr.detectChanges();
  }

  buildForm() {
    this.form = this._formBuilder.group({
      name:         [this.product?.name ?? '',            Validators.required],
      description:  [this.product?.description ?? ''],
      categoryName: [this.product?.categoryName ?? ''],
      // categoryId:   [this.product?.categoryId ?? null],
      supplierId:   [this.product?.supplierId ?? null],
      price:        [this.product?.price ?? 0],
      standbyPrice: [this.product?.standbyPrice ?? 0],
      serialNumber: [this.product?.serialNumber ?? '',    Validators.required],
      location:     [this.product?.location ?? '',        Validators.required],
      // cost:         [this.product?.cost ?? 0],
      // stock:        [this.product?.stock ?? 0],
      calibrationDueDate: [this.product?.calibrationDueDate],
      serviceDueDate: [this.product?.serviceDueDate],
      swimlaneId:   [this.product?.swimlaneId ?? this.swimlanes[0]?.id,    Validators.required],
    });
  }

  getSupplierName(supplierId: number) {
    return this.suppliers.find(x => x.supplierId == supplierId)?.name ?? '';
  }

    
  filterCategories(event: any) {
      this.filteredCategories = this.categories.filter(m => m.title.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  onCategorySelected(category: ProductCategoryDto) {
      console.log("cat selected", category);
      return;
      if(this.selectedCategory?.productCategoryId == category?.productCategoryId) return;

      this.selectedCategory = category;
      this.form?.controls["categoryName"].setValue(category?.title);

      this.cdr.detectChanges();
  }

  toggleService(event: MatSlideToggleChange) {
    this.product.annualServiceRequired = event.checked;
  }


  async buildModel() {
    var product = this.form.value;

    this.product.name = product.name;
    this.product.description = product.description;
    this.product.supplierId = product.supplierId;
    // this.product.stock = product.stock;
    this.product.price = product.price;
    this.product.standbyPrice = product.standbyPrice;
    // this.product.cost = product.cost;
    this.product.serialNumber = product.serialNumber;
    this.product.location = product.location;
    this.product.swimlaneId = product.swimlaneId;

    this.product.calibrationDueDate = product.calibrationDueDate;
    this.product.serviceDueDate = product.serviceDueDate;

    if(!this.product.annualServiceRequired)
      this.product.serviceDueDate = null;

    var existingCategory = this.categories.find(x => x.title.toLowerCase().trim() == product.categoryName.toLowerCase().trim());

    if(existingCategory) {
      this.product.categoryId = existingCategory.productCategoryId;
    }
    else {
      if(!product.categoryName.trim()) {
        this.product.categoryId = null;
      }
      else
      {
        var request = <ProductCategoryDto>{
          name: product.categoryName,
          colour: ColourUtil.getRandomMidColour(), //todo
        }
        var res = await this.assetService.apiProductAddCategoryPost$Json$Response({body: request}).toPromise();
        if(!res?.body?.data) return false;

        this.product.categoryId = res.body.data.productCategoryId;
        this.loadCategories();
      }
    }

    return true;
  }

  async save() {
    var res = await this.buildModel();

    if(res)
      this.close(this.product);
  }

  close(result: ProductDto = null) {
    this.dialogRef.close(result);
  }
}
